export const deriveSerialPrefix = (
  name?: string | null,
  code?: string | null,
  brand?: string | null,
): string => {
  if (brand && typeof brand === 'string' && brand.trim()) {
    const cleanBrand = brand.trim().replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    if (cleanBrand.length >= 2) {
      return cleanBrand.slice(0, 6);
    }
  }
  if (name && typeof name === 'string' && name.trim()) {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length > 0) {
      const firstWord = words[0].replace(/[^A-Za-z0-9]/g, '').toUpperCase();
      if (firstWord.length >= 2) {
        return firstWord.slice(0, 6);
      }
    }
    const cleanName = name.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    if (cleanName.length >= 2) {
      return cleanName.slice(0, 4);
    }
  }
  if (code && typeof code === 'string' && code.trim()) {
    const upperCode = code.trim().toUpperCase();
    if (!upperCode.startsWith('ITM-') && !upperCode.startsWith('ITM')) {
      const cleanCode = upperCode.replace(/[^A-Za-z0-9]/g, '');
      if (cleanCode.length >= 2) {
        return cleanCode.slice(0, 4);
      }
    }
  }
  return 'SN';
};
